import {uniq} from 'lodash';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tab} from 'semantic-ui-react';

import * as RunHelpers from '../../../util/runhelpers';
import {useKeyInfoQueryContext} from '../../MultiRunWorkspace/KeyInfoQueryContext';
import {useSingleRunModeContext} from '../../MultiRunWorkspace/SingleRunMode';
import {PanelExpressionOptions} from '../../PanelExpressionOptions';
import {usePanelConfigContext} from '../PanelConfigContext';
import {type RunsLinePlotConfig} from '../types';
import {useXYChoices} from './useXYChoices';

type EditExpressionsTabProps = {
  updateConfig: (config: Partial<RunsLinePlotConfig>) => void;
  config: RunsLinePlotConfig;
};

export const EditExpressionsTab = (props: EditExpressionsTabProps) => {
  const {config} = props;
  const {xAxis} = usePanelConfigContext();
  const {isSingleRun} = useSingleRunModeContext();

  const {
    keyInfoQuery: {historyKeyInfo: keyInfo},
  } = useKeyInfoQueryContext();

  const keyTypes = RunHelpers.useKeyTypes(keyInfo.keys);

  const {xAxisChoices, yAxisChoices} = useXYChoices({
    config,
    keyInfo,
    keyTypes,
    isSingleRun,
    xAxis,
  });

  return (
    <Tab.Pane as="div" className="form-grid">
      <PanelExpressionOptions
        availableExpressionVarNames={uniq([...xAxisChoices, ...yAxisChoices])}
        config={props.config}
        exampleIdentifier={props.config.metrics?.[0] || 'x'}
        type={'lines'}
        updateConfig={props.updateConfig}
      />
    </Tab.Pane>
  );
};
